import React from "react";
import Breadclumbs from "./Breadclumbs";
import Headlins from "./Headlins";
import Cart from "./Cart";

function About() {
  return (
    <div>
      <Breadclumbs />
      <Headlins suptitle={"About by category"} title={"About by category"} />
      <div className="About">
        <Cart />
        <Cart />
        <Cart />
        <Cart />
        <Cart />
        <Cart />
        <Cart />
        <Cart />
        <Cart />
        <Cart />
      </div>
    </div>
  );
}

export default About;
